import { Field, Label } from '@headlessui/react'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './DatePickerField.css';

interface IYearDatePickerFieldProps {
  label: string
  placeholder: string
  value?: number | null
  onChange?: (year: number | null) => void
  error?: boolean
}

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

export const YearDatePickerField = (props: IYearDatePickerFieldProps) => {
  const dateValue = props.value ? new Date(props.value, 0, 1) : null
  
  const handleChange = (value: Value) => {
    if (value instanceof Date) {
      props.onChange?.(value.getFullYear())
    } else {
      props.onChange?.(null)
    }
  }
  
  return (
    <Field>
      <Label className={'text-lg'}>{props.label}</Label>
      <div className={'relative mt-3'}>
        <DatePicker
          className={props.error ? 'date-picker-field date-picker-error' : 'date-picker-field'}
          calendarIcon={null}
          clearIcon={null}
          value={dateValue}
          onChange={handleChange}
          maxDetail={'decade'}
          format={'y'}
          minDate={new Date(1900, 0, 1)}
          maxDate={new Date()}
          yearPlaceholder={props.placeholder}
        />
      </div>
    </Field>
  )
}
